import React from "react";
import "./AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-content">
        <div className="about-header">
          <h1>//ABOUT TEAM ENCIPHERX 4.0</h1>
        </div>

        <div className="about-main">
          <div className="about-text">
            <p>
              Welcome to Vidarbha's premier CTF team, proudly representing
              Phoenix Cybersecurity. Our team comprises 18 dedicated security
              enthusiasts and challenge creators who are committed to advancing
              cybersecurity education. We're excited to present the region's
              largest 24-hour Capture The Flag competition, pushing the
              boundaries of cybersecurity education and competition.
            </p>
          </div>

          <div className="team-stats">
            <div className="stat-card">
              <div className="stat-number">18</div>
              <div className="stat-label">TEAM MEMBERS</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24</div>
              <div className="stat-label">HOURS CTF</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">1st</div>
              <div className="stat-label">REGION'S LARGEST</div>
            </div>
          </div>
        </div>

        <div className="ctf-experience">
          <h2>//THE ULTIMATE CTF EXPERIENCE</h2>
          <div className="experience-content">
            <p>
              Join us for an intense 24-hour journey through carefully crafted
              challenges that will test your skills, creativity, and
              persistence. Our team has developed a diverse range of challenges
              across multiple domains, ensuring an engaging experience for both
              beginners and seasoned professionals.
            </p>
          </div>
        </div>

        <div className="expertise-highlights">
          <div className="expertise-panel">
            <h2>Our Expertise</h2>
            <ul className="expertise-list">
              <li>Web Security & Exploitation</li>
              <li>Reverse Engineering</li>
              <li>Cryptography</li>
              <li>Binary Exploitation</li>
              <li>Digital Forensics</li>
              <li>Network Security</li>
              <li>OSINT Challenges</li>
            </ul>
          </div>

          <div className="highlights-panel">
            <h2>Team Highlights</h2>
            <ul className="highlights-list">
              <li>Industry-Standard Training Methodologies</li>
              <li>Hands-on Lab Environment</li>
              <li>Live Project Experience</li>
              <li>24/7 Support During CTF Event</li>
              <li>Regular Training Sessions</li>
              <li>Collaborative Learning Environment</li>
              <li>Access to Premium Resources</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
